export const SUCCESS_RESULT_CODES = ['Authorised'];
// Adyen accepted the request but the bank has not authorised yet (Pay by bank, Sofort, SEPA): the order
// is still unpaid until the AUTHORISATION webhook, so these go to the thank-you page as pending.
export const PENDING_RESULT_CODES = ['Pending', 'Received'];
export const ADYEN_ERROR_STATUS_CODES = [422];
export const REFUSAL_REASON_CODES = ['11', '2'];

export const SEARCH_PARAM_FOR_NAV_TO_SELECT_TREATMENT = 'roos';

export const TRUSTEDSHOP_COUNTRIES = ['DE', 'CH'];
export const COUNTRIES_WITH_TREATMENT_FEE = ['DE', 'CH'];
// FR price breakdown is gated via shouldShowPriceBreakdown() + catalogs.is_subsidized (not always-on).

export const VOUCHER_ERROR_HANDLERS: Record<string, { titleKey: string; contentKey: string; reason: string }> = {
  sale_voucher_missing: {
    titleKey: 'vouchers/sale_voucher_missing_title',
    contentKey: 'vouchers/sale_voucher_missing',
    reason: 'sale voucher missing',
  },
  sale_voucher_already_used: {
    titleKey: 'vouchers/sale_voucher_already_used_title',
    contentKey: 'vouchers/sale_voucher_already_used',
    reason: 'sale voucher already used',
  },
  sale_voucher_exhausted: {
    titleKey: 'vouchers/sale_voucher_exhausted_title',
    contentKey: 'vouchers/sale_voucher_exhausted',
    reason: 'sale voucher exhausted',
  },
  sale_voucher_expired: {
    titleKey: 'vouchers/sale_voucher_expired_title',
    contentKey: 'vouchers/sale_voucher_expired',
    reason: 'sale voucher expired',
  },
  invalid_sale_voucher: {
    titleKey: 'vouchers/invalid_sale_voucher_title',
    contentKey: 'vouchers/invalid_sale_voucher',
    reason: 'invalid sale voucher',
  },
};
